export class Regexs {
  private constructor() {}

  public static EMAIL_REGEX =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static regexAmount = /^[0-9]*.?[0-9]{0,3}$/;
  public static regexAccountNumber = /^[0-9]{20}$/;
  public static regexCiRif = /^[V|E|J|G|C|I|R][0-9]{5,9}$|[P][A-Za-z0-9]{3,12}$/;
  public static regexPhoneNumber = /^[+0-9]{7,14}$/;
}
